const OriginTypes = {
  qbo: 'qbo'
}

const CompanyTypes = {
  NG: 'NG',
  KE: 'KE'
}

const ObjTypes = {
  deposit: 'deposit',
  invoice: 'invoice',
  creditmemo: 'creditmemo',
  payment: 'payment',
  journalentry: 'journalentry',
  purchase: 'purchase',
  account: 'account',
  customer: 'customer'
}

const TxnTypes = [
  ObjTypes.deposit,
  ObjTypes.invoice,
  ObjTypes.creditmemo,
  ObjTypes.payment,
  ObjTypes.journalentry,
  ObjTypes.purchase
]

module.exports = {
  OriginTypes,
  CompanyTypes,
  ObjTypes,
  TxnTypes
}
